import {
	gfmStrikethroughFromMarkdown,
	gfmStrikethroughToMarkdown,
} from "mdast-util-gfm-strikethrough";
import { gfmStrikethrough } from "micromark-extension-gfm-strikethrough";
import { type Processor } from "unified";

export function remarkStrikethrough(this: Processor) {
	const data = this.data();

	const micromarkExtensions = data.micromarkExtensions || (data.micromarkExtensions = []);
	const fromMarkdownExtensions =
		data.fromMarkdownExtensions || (data.fromMarkdownExtensions = []);
	const toMarkdownExtensions = data.toMarkdownExtensions || (data.toMarkdownExtensions = []);

	micromarkExtensions.push(gfmStrikethrough({ singleTilde: false }));
	fromMarkdownExtensions.push(gfmStrikethroughFromMarkdown());
	toMarkdownExtensions.push(gfmStrikethroughToMarkdown());
}
